module.exports = __webpack_public_path__ + "img/lovetoeatacow.9ca940bb.jpg";